//
// Generated class ScheduledReport
//

/// <reference path="ScheduledReport_ManagedObject.ts" />

class ScheduledReport extends ScheduledReport_ManagedObject
{

}
